export default {
    create_unittype_create_title: "Nuevo tipo de unidad",
    create_unittype_edit_title: "Editar tipo de unidad",
    create_unittype_create_success_message: "Se ha creado el tipo de unidad",
    create_unittype_update_success_message: "El tipo de unidad ha sido editado",
    create_unittype_manufacturer: "Fabricante",
    create_unittype_name: "Nombre",
    create_unittype_uses_sim: "Usa SIM",
    create_unittype_use_imei_as_serial: "Usar IMEI como Número de Serial",
    create_unittype_active: "Activo",
    create_unittype_database: "Base de datos",
    create_unittype_error_create_general: "Error al crear el tipo de unidad",
    create_unittype_error_update_general: "Error al actualizar el tipo de unidad",
    create_unittype_error_same_name: "Ya existe un tipo de unidad con el mismo nombre",
}